if (!customElements.get("product-info")) {
  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector(".quantity__input");
        this.currentVariantPrice = 0;
        this.totalPrice = 0;
        this.selectedRedValue = null
        this.selectedVariantData = null
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.initOffCanvasMenu();
        this.initSpecificationsToggle();
        this.initSpecialInstructionToggle();
        this.initReadMoreToggle();
        this.dispatchEvent(
          new CustomEvent("product-info:loaded", { bubbles: true })
        );
        document.addEventListener("vehicleRedSelection:changed", (event) => {
          this.updateMainPrice();
        })
      }
      initReadMoreToggle() {
        const descriptionContent = document.querySelector(
          ".product__description-content"
        );

        if (descriptionContent) {
          const fullHTML = descriptionContent.innerHTML.trim(); // Preserve HTML structure
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = fullHTML;

          // Responsive word limit
          const wordLimit = window.innerWidth <= 1286 ? 16 : 25;
          const words = tempDiv.textContent.trim().split(/\s+/);

          if (words.length > wordLimit) {
            const truncatedText = words.slice(0, wordLimit).join(" ") + "...";

            descriptionContent.innerHTML = `
        <span class="truncated">${truncatedText}</span>
        <span class="full-text hidden">${fullHTML}</span>
      `;

            const toggleLink = document.createElement("a");
            toggleLink.className = "read-more-toggle";
            toggleLink.href = "javascript:void(0);";
            toggleLink.textContent = "read more";
            descriptionContent.appendChild(toggleLink);

            toggleLink.addEventListener("click", () => {
              const truncated = descriptionContent.querySelector(".truncated");
              const fullTextSpan =
                descriptionContent.querySelector(".full-text");

              if (descriptionContent.classList.contains("expanded")) {
                descriptionContent.classList.remove("expanded");
                truncated.classList.remove("hidden");
                fullTextSpan.classList.add("hidden");
                toggleLink.textContent = "read more";
              } else {
                descriptionContent.classList.add("expanded");
                truncated.classList.add("hidden");
                fullTextSpan.classList.remove("hidden");
                toggleLink.textContent = "read less";
              }
            });
          }
        }
      }
      initSpecialInstructionToggle() {
        const toggleSwitch = this.querySelector("#special-instruction-toggle");
        const textarea = this.querySelector("#special-instruction-textarea");

        if (toggleSwitch && textarea) {
          toggleSwitch.addEventListener("click", () => {
            // Toggle the active class on the slider
            toggleSwitch.classList.toggle("active");

            // Show or hide the textarea based on the toggle state
            if (toggleSwitch.classList.contains("active")) {
              textarea.style.display = "block"; // Show the textarea
            } else {
              textarea.style.display = "none"; // Hide the textarea
            }
          });
        }
      }
      initSpecificationsToggle() {
        const toggleButton = this.querySelector("#toggle-specifications");
        const specificationsPanel = this.querySelector(
          "#product-specifications-panel"
        );

        if (toggleButton && specificationsPanel) {
          toggleButton.addEventListener("click", () => {
            specificationsPanel.classList.toggle("visible"); // Toggle the visibility of the panel
          });
        }
      }
      initOffCanvasMenu() {
        // Drawer 1
        const openModal1 = document.querySelector("#open-modal-1");
        const closeModal1 = document.querySelector("#close-modal-1");
        const modal1 = document.querySelector("#modal-1");
        const overlay1 = modal1?.querySelector(".modal-overlay");

        // Drawer 2
        const openModal2 = document.querySelector("#open-modal-2");
        const closeModal2 = document.querySelector("#close-modal-2");
        const modal2 = document.querySelector("#modal-2");
        const overlay2 = modal2?.querySelector(".modal-overlay");

        // Drawer 3
        const openModal3 = document.querySelector("#open-modal-3");
        const closeModal3 = document.querySelector("#close-modal-3");
        const modal3 = document.querySelector("#modal-3");
        const overlay3 = modal3?.querySelector(".modal-overlay");

        // Function to open a modal
        function openModal(modal) {
          if (modal) {
            modal.classList.add("visible"); // Show the modal
            modal.classList.remove("hidden"); // Ensure hidden is removed
            document.body.classList.add("modal-open"); // Prevent scrolling on the page
            document.body.classList.add("modal-active"); // Add overlay to block PDP content
          }
        }

        // Function to close a modal
        function closeModal(modal) {
          if (modal) {
            modal.classList.remove("visible"); // Hide the modal
            modal.classList.add("hidden"); // Ensure hidden is added back
            document.body.classList.remove("modal-open"); // Re-enable scrolling
            document.body.classList.remove("modal-active"); // Remove overlay blocking PDP content
          }
        }

        // Add event listeners for Drawer 1
        if (openModal1 && closeModal1 && modal1 && overlay1) {
          openModal1.addEventListener("click", (event) => {
            event.preventDefault(); // Prevent default button behavior
            openModal(modal1);
          });

          closeModal1.addEventListener("click", (event) => {
            event.preventDefault(); // Prevent default button behavior
            closeModal(modal1);
          });

          // Close modal when clicking on the overlay
          overlay1.addEventListener("click", () => closeModal(modal1));
        }

        // Add event listeners for Drawer 2
        if (openModal2 && closeModal2 && modal2 && overlay2) {
          openModal2.addEventListener("click", (event) => {
            event.preventDefault(); // Prevent default button behavior
            openModal(modal2);
          });

          closeModal2.addEventListener("click", (event) => {
            event.preventDefault(); // Prevent default button behavior
            closeModal(modal2);
          });

          // Close modal when clicking on the overlay
          overlay2.addEventListener("click", () => closeModal(modal2));
        }

        // Add event listeners for Drawer 3
        if (openModal3 && closeModal3 && modal3 && overlay3) {
          openModal3.addEventListener("click", (event) => {
            event.preventDefault();
            openModal(modal3);
          });
        
          closeModal3.addEventListener("click", (event) => {
            event.preventDefault();
            closeModal(modal3);
          });
        
          overlay3.addEventListener("click", () => closeModal(modal3));
        }

        // Close modal when clicking anywhere outside the modal content
        document.addEventListener("click", (event) => {
          if (
            modal1?.classList.contains("visible") &&
            !modal1.querySelector(".modal-content").contains(event.target) &&
            !openModal1.contains(event.target)
          ) {
            closeModal(modal1);
          }

          if (
            modal2?.classList.contains("visible") &&
            !modal2.querySelector(".modal-content").contains(event.target) &&
            !openModal2.contains(event.target)
          ) {
            closeModal(modal2);
          }

          if (
            modal3?.classList.contains("visible") &&
            !modal3.querySelector(".modal-content").contains(event.target) &&
            !openModal3.contains(event.target)
          ) {
            closeModal(modal3);
          }
        });
      }
      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector(".product-form__quantity");
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html
            .querySelectorAll(".scroll-trigger")
            .forEach((element) =>
              element.classList.add("scroll-trigger--cancel")
            )
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({
        data: { event, target, selectedOptionValues },
      }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl =
          target.dataset.productUrl ||
          this.pendingRequestUrl ||
          this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage =
          this.dataset.updateUrl === "true" && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(
            productUrl,
            selectedOptionValues,
            shouldFetchFullPage
          ),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage
            ? "product-info[id^='MainProduct']"
            : "product-info";
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector("head title").innerHTML =
              html.querySelector("head title").innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector("main"),
              html.querySelector("main"),
              this.preProcessHtmlCallbacks,
              this.add
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector("product-info"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === "AbortError") {
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector(
          "variant-selects [data-selected-variant]"
        )?.innerHTML;
        this.selectedVariantData = JSON.parse(selectedVariant)
        
        console.log("selected variant", JSON.parse(selectedVariant));
        const isRedPresent = document.querySelector("product-form").dataset.redUpsell !== undefined
        isRedPresent && this.updateMainPrice();
        console.log("selected value is", this.selectedRedValue);
        
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      updatePriceHTML() {
        const priceContainers = document.querySelectorAll(["product-form .product-form__buttons-price .price__regular .price-item.price-item--regular", "product-form .product-form__buttons-price .price__sale .price-item.price-item--sale"])
        priceContainers.forEach(itm => {
          itm.innerHTML = `${ window.storeCountry.symbol} ${this.totalPrice.toFixed(2)}`;
        });

        // Main price box - regular price
        const mainPriceContainer = this.querySelector(`.price-box .price__regular .price-item.price-item--regular .product__price`);
        if (mainPriceContainer) {
          mainPriceContainer.innerHTML = `${window.storeCountry.symbol} ${this.totalPrice.toFixed(2)}`;
        }

        // Main price box - sale price
        const mainSalePriceContainer = this.querySelector(`.price-box .price__sale .price-item.price-item--sale.price-item--last`);
        if (mainSalePriceContainer) {
          mainSalePriceContainer.innerHTML = `${window.storeCountry.symbol} ${this.totalPrice.toFixed(2)}`;
        }
      }
      
      updateMainPrice() {
        const redPrice = JSON.parse(document.querySelector("product-form").dataset.redUpsell).price / 100;
        this.currentVariantPrice = Number(this.selectedVariantData.price) / 100;
        this.selectedRedValue === "yes" ? this.totalPrice = this.currentVariantPrice + redPrice : this.totalPrice = this.currentVariantPrice;
        this.updatePriceHTML()
      }

      buildRequestUrlWithParams(
        url,
        optionValues,
        shouldFetchFullPage = false
      ) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(",")}`);
        }

        return `${url}?${params.join("&")}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector("variant-selects");
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(
            this.variantSelectors,
            variantSelects,
            this.preProcessHtmlCallbacks
          );
        }
      }

      isColorSelected() {
        const selectedColorText = document.getElementById('selectedColorText');
        return selectedColorText && selectedColorText.textContent !== 'Please select';
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (
            id,
            shouldHide = (source) => false
          ) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(
              `#${id}-${this.dataset.section}`
            );
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle("hidden", shouldHide(source));
            }
          };

          updateSourceFromDestination("price");
          updateSourceFromDestination("price-button");
          updateSourceFromDestination("Sku", ({ classList }) =>
            classList.contains("hidden")
          );
          updateSourceFromDestination(
            "Inventory",
            ({ innerText }) => innerText === ""
          );
          updateSourceFromDestination("Volume");
          updateSourceFromDestination("Price-Per-Item", ({ classList }) =>
            classList.contains("hidden")
          );

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(
            `#Quantity-Rules-${this.dataset.section}`
          )?.classList.remove("hidden");
          this.querySelector(
            `#Volume-Note-${this.dataset.section}`
          )?.classList.remove("hidden");

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute("disabled") && !this.isColorSelected(),
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });

        const isRedPresent = document.querySelector("product-form").dataset.redUpsell !== undefined
        isRedPresent && this.updateMainPrice();
          
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? "";
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector("share-button")?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ""}`
        );

        if (this.dataset.updateUrl === "false") return;
        window.history.replaceState(
          {},
          "",
          `${url}${variantId ? `?variant=${variantId}` : ""}`
        );
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(
          true,
          window.variantStrings.unavailable
        );

        const selectors = [
          "price",
          "Inventory",
          "Sku",
          "Price-Per-Item",
          "Volume-Note",
          "Volume",
          "Quantity-Rules",
        ]
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(", ");
        document
          .querySelectorAll(selectors)
          .forEach(({ classList }) => classList.add("hidden"));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector("media-gallery ul");
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute("data-zoom-on-hover")) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(
            mediaGallerySource.querySelectorAll("li[data-media-id]")
          );
          const sourceSet = new Set(
            mediaGallerySourceItems.map((item) => item.dataset.mediaId)
          );
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [
              item.dataset.mediaId,
              { item, index },
            ])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] =
            refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll("li[data-media-id]")
          );
          const destinationSet = new Set(
            mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId)
          );
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (
              !sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)
            ) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (
              !destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)
            ) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh)
            [mediaGallerySourceItems, sourceSet, sourceMap] =
              refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach(
            (destinationItem, destinationIndex) => {
              const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

              if (sourceData && sourceData.index !== destinationIndex) {
                mediaGallerySource.insertBefore(
                  sourceData.item,
                  mediaGallerySource.querySelector(
                    `li:nth-of-type(${destinationIndex + 1})`
                  )
                );

                // refresh source now that it has been modified
                [mediaGallerySourceItems, sourceSet, sourceMap] =
                  refreshSourceData();
              }
            }
          );
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(
          `.product-media-modal__content`
        );
        const newModalContent = html.querySelector(
          `product-modal .product-media-modal__content`
        );
        if (modalContent && newModalContent)
          modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity
            ? parseInt(this.quantityInput.dataset.cartQuantity)
            : 0,
          min: this.quantityInput.dataset.min
            ? parseInt(this.quantityInput.dataset.min)
            : 1,
          max: this.quantityInput.dataset.max
            ? parseInt(this.quantityInput.dataset.max)
            : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute("max");
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector(
          ".quantity__rules-cart .loading__spinner"
        ).classList.remove("hidden");
        fetch(
          `${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`
        )
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() =>
            this.querySelector(
              ".quantity__rules-cart .loading__spinner"
            ).classList.add("hidden")
          );
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(
          `Quantity-Form-${sectionId}`
        );
        const selectors = [
          ".quantity__input",
          ".quantity__rules",
          ".quantity__label",
        ];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === ".quantity__input") {
            const attributes = [
              "data-cart-quantity",
              "data-min",
              "data-max",
              "step",
            ];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector("variant-selects");
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          "related-products"
        );
        return document.querySelector(
          `product-recommendations[data-section-id^="${relatedProductsSectionId}"]`
        );
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          "quick_order_list"
        );
        return document.querySelector(
          `quick-order-list[data-id^="${quickOrderListSectionId}"]`
        );
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
document.addEventListener("DOMContentLoaded", function () {
  const dropdownToggles = document.querySelectorAll(".dropdown-toggle");

  dropdownToggles.forEach((toggle) => {
    toggle.addEventListener("click", function () {
      const content = this.nextElementSibling;

      // Toggle the visibility of the dropdown content
      if (content.style.display === "block") {
        content.style.display = "none";
        this.setAttribute("aria-expanded", "false"); // Update aria-expanded
      } else {
        content.style.display = "block";
        this.setAttribute("aria-expanded", "true"); // Update aria-expanded
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const promoTimerElement = document.querySelector(".promo-timer");
  const promoTextBeforeTimer = document.querySelector(
    ".promo-text-before-timer"
  );
  const promoTextAfterTimer = document.querySelector(".promo-text-after-timer");
  const promoBox = document.querySelector(".promo-box");

  // Chevron Kits have an earlier order cut-off time (1 PM instead of 5 PM)
  const isChevronKit = promoBox && promoBox.dataset.productType === "Chevron Kits";
  const cutoffHour = isChevronKit ? 13 : 17;

  function updatePromoMessage() {
    const now = new Date();
    const ukNow = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/London' })); 
    const currentHour = ukNow.getHours();
    const currentDay = ukNow.getDay();
  
    if ((currentDay === 4 && currentHour >= cutoffHour) || (currentDay === 5 && currentHour < cutoffHour)) {
      // Thursday after cut-off OR Friday before cut-off → ships Friday, delivers Monday
      promoTextBeforeTimer.textContent = "Order in the next";
      promoTimerElement.textContent = calculateRemainingTime(now, "Monday", cutoffHour);
      promoTextAfterTimer.textContent = "for Monday delivery.";
    } else if ((currentDay === 5 && currentHour >= cutoffHour) || currentDay === 6 || currentDay === 0) {
      // Friday after cut-off OR Saturday OR Sunday → ships Monday, delivers Tuesday
      promoTextBeforeTimer.textContent = "Order in the next";
      promoTimerElement.textContent = calculateRemainingTime(now, "Tuesday", cutoffHour);
      promoTextAfterTimer.textContent = "for Tuesday delivery.";
    } else {
      // Mon–Thu before cut-off, or Mon–Wed after cut-off → next day delivery
      promoTextBeforeTimer.textContent = "Order in the next";
      promoTimerElement.textContent = calculateRemainingTime(now, "NextDay", cutoffHour);
      promoTextAfterTimer.textContent = "for next day delivery.";
    }
  }

  // Call the function to update the promo message
  updatePromoMessage();

  // Optional: Update the timer periodically (e.g., every minute)
  setInterval(updatePromoMessage, 60000); // Update every 60 seconds
});

function calculateRemainingTime(currentTime, deliveryDay, cutoffHour) {
  cutoffHour = cutoffHour || 17;
  const ukNow = new Date(currentTime.toLocaleString('en-US', { timeZone: 'Europe/London' }));
  const offsetMs = ukNow - currentTime;

  const cutoffUK = new Date(ukNow);

  if (deliveryDay === "NextDay") {
    cutoffUK.setHours(cutoffHour, 0, 0, 0);
    if (ukNow.getHours() >= cutoffHour) {
      cutoffUK.setDate(cutoffUK.getDate() + 1);
    }
  } else if (deliveryDay === "Monday") {
    // Countdown to Friday cut-off
    cutoffUK.setHours(cutoffHour, 0, 0, 0);
    if (ukNow.getDay() === 4) {
      // It's Thursday after cut-off, cutoff is tomorrow (Friday)
      cutoffUK.setDate(cutoffUK.getDate() + 1);
    }
    // If it's Friday before cut-off, cutoff is today (already set)
  } else if (deliveryDay === "Tuesday") {
    // Countdown to Monday cut-off
    cutoffUK.setHours(cutoffHour, 0, 0, 0);
    const daysUntilMonday = (1 - ukNow.getDay() + 7) % 7;
    cutoffUK.setDate(cutoffUK.getDate() + (daysUntilMonday === 0 ? 7 : daysUntilMonday));
  }

  const cutoffReal = new Date(cutoffUK.getTime() - offsetMs);
  const remainingTime = cutoffReal - currentTime;
  const hours = Math.floor(remainingTime / (1000 * 60 * 60));
  const minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));

  return `${hours} Hours ${minutes} Minutes`;
}
